import { render, staticRenderFns } from "./verify-edit.vue?vue&type=template&id=bd64389e&scoped=true&"
import script from "./verify-edit.vue?vue&type=script&lang=ts&"
export * from "./verify-edit.vue?vue&type=script&lang=ts&"
import style0 from "./verify-edit.vue?vue&type=style&index=0&id=bd64389e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd64389e",
  null
  
)

export default component.exports